import * as React from "react";
import styled from "styled-components";

import {
  Grid,
  Hidden,
  List,
  ListItemText,
  ListItem as MuiListItem,
  ListItemProps as MuiListItemProps
} from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface ListItemProps extends MuiListItemProps {
  component?: string;
  href?: string;
  button?: boolean;
}

const Wrapper = styled.div`
  padding: ${props => props.theme.spacing(1) / 4}px
    ${props => props.theme.spacing(4)}px;
  background: ${props => props.theme.palette.common.white};
  position: relative;
`;

const ListItem = styled(MuiListItem)<ListItemProps>`
  display: inline-block;
  width: auto;
  padding-left: ${props => props.theme.spacing(2)}px;
  padding-right: ${props => props.theme.spacing(2)}px;

  &,
  &:hover,
  &:active {
    color: #000;
  }
`;

function Footer() {
  const {t} = useTranslation(["general"]);
  return (
    <Wrapper>
      <Grid container spacing={0}>
        <Hidden smDown>
          <Grid container item xs={12} md={6}>
            {/*<List>
              <ListItem button={true} component="a" href="https://t.me/RestifyOneSupportBot">
                <ListItemText primary="Поддержка" />
              </ListItem>
              <ListItem button={true} component="a" href="#">
                <ListItemText primary="Помощь" />
              </ListItem>
            </List>*/}
          </Grid>
        </Hidden>
        <Grid container item xs={12} md={6} justify="flex-end">
          <List>
            <ListItem button={true} component="a" href="https://t.me/restify_one">
              <ListItemText primary={t("general:support")} />
            </ListItem>
            <ListItem button={undefined}>
              <ListItemText primary={`© 2020 - ${new Date().getFullYear()} - restify.one `} />
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </Wrapper>
  );
}

export default Footer;
